import {WebsiteSidebarSubMenu} from "./website-sidebar-sub-menu.model";
import {
  IWebsiteSidebarSimpleItem
} from "../website-sidebar-simple-item/website-sidebar-simple-item.model";

export interface IWebsiteSidebarSubMenuBuilder {
  setImg: (img: string) => WebsiteSidebarSubMenuBuilder;
  setIcon: (icon: string) => WebsiteSidebarSubMenuBuilder;
  setSubMenu: (subMenu: IWebsiteSidebarSimpleItem[]) => WebsiteSidebarSubMenuBuilder;
  setPageIds: (pageIds: string[]) => WebsiteSidebarSubMenuBuilder;
  setDisabled: (disabled: boolean) => WebsiteSidebarSubMenuBuilder;
  build: () => WebsiteSidebarSubMenu;
}

export class WebsiteSidebarSubMenuBuilder implements IWebsiteSidebarSubMenuBuilder {
  private readonly product: WebsiteSidebarSubMenu;

  constructor(name: string, label: string, type: 'static' | 'dropdown' | 'accordion') {
    this.product = new WebsiteSidebarSubMenu(name, label, type);
  }

  setImg(img: string): WebsiteSidebarSubMenuBuilder {
    this.product.img = img;
    return this;
  }

  setIcon(icon: string): WebsiteSidebarSubMenuBuilder {
    this.product.icon = icon;
    return this;
  }

  setSubMenu(subMenu: IWebsiteSidebarSimpleItem[]): WebsiteSidebarSubMenuBuilder {
    this.product.subMenu = subMenu;
    return this;
  }

  setPageIds(pageIds: string[]): WebsiteSidebarSubMenuBuilder {
    this.product.setPageIds(pageIds);
    return this;
  }

  setDisabled(disabled: boolean): WebsiteSidebarSubMenuBuilder {
    this.product.disabled = disabled;
    return this;
  }

  setAdvanced(advanced: boolean): WebsiteSidebarSubMenuBuilder {
    this.product.advanced = advanced;
    return this;
  }

  build(): WebsiteSidebarSubMenu {
    return this.product;
  }
}
